import { render } from "./FeaturesCards.vue?vue&type=template&id=5c249002&scoped=true&ts=true"
import script from "./FeaturesCards.vue?vue&type=script&lang=ts"
export * from "./FeaturesCards.vue?vue&type=script&lang=ts"

import "./FeaturesCards.vue?vue&type=style&index=0&id=5c249002&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c249002"]])

export default __exports__